import { render, staticRenderFns } from "./ReportsTableMobile.vue?vue&type=template&id=1b5c968b&lang=pug"
import script from "./ReportsTableMobile.vue?vue&type=script&lang=js"
export * from "./ReportsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports